export default {
  path: '*',
  redirect: '/404',
  hidden: true,
};
